import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { fmtDateTime } from "@/lib/constants";
import StatusBadge from "@/components/StatusBadge";
import { Card, CardContent } from "@/components/ui/card";
import { PackageCheck } from "lucide-react";

export default function ReadyJobs() {
  const navigate = useNavigate();
  const [jobs, setJobs] = useState(null);

  useEffect(() => {
    api.get("/jobs?status=Ready").then((r) => setJobs(r.data)).catch(() => setJobs([]));
  }, []);

  return (
    <div data-testid="ready-jobs-page">
      <div className="flex items-center gap-3">
        <PackageCheck className="h-7 w-7 text-primary" />
        <h1 className="font-display text-2xl sm:text-3xl font-semibold tracking-tight">Ready for Delivery</h1>
      </div>
      <p className="text-sm text-muted-foreground mt-1">Jobs that passed quality check and await customer pickup / delivery.</p>

      <div className="space-y-2 mt-5" data-testid="ready-jobs-list">
        {jobs === null ? (
          <p className="text-sm text-muted-foreground">Loading…</p>
        ) : jobs.length === 0 ? (
          <Card><CardContent className="p-8 text-center text-sm text-muted-foreground" data-testid="ready-jobs-empty">No jobs are ready for delivery right now.</CardContent></Card>
        ) : jobs.map((j) => (
          <button key={j.id} onClick={() => navigate(`/jobs/${j.id}`)} data-testid={`ready-job-${j.id}`}
            className="w-full flex items-center gap-3 rounded-xl border bg-card px-4 py-3.5 hover:bg-accent/50 transition-colors text-left">
            <div className="min-w-0 flex-1">
              <p className="text-sm font-semibold truncate">{j.job_number} · {j.article_name}</p>
              <p className="text-xs text-muted-foreground truncate">{j.customer_name} · {j.customer_mobile}</p>
              <p className="text-xs text-muted-foreground mt-0.5">{(j.required_finishes || []).join(", ")} · received {fmtDateTime(j.created_at)}</p>
            </div>
            <StatusBadge status={j.status} />
          </button>
        ))}
      </div>
    </div>
  );
}
